import padStart from 'lodash/padStart';

export function formatDate(date, db = false) {
  if (date === null) return null;
  const d = new Date(date);
  let month = d.getMonth() + 1;
  let day = d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = `${0 + month}`;
  if (day.length < 2) day = `${0 + day}`;

  return db ? [year, month, day].join('-') : [day, month, year].join('/');
}

export function shuffleArray(someArr) {
  const a = [...someArr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function getDateInfo(date) {
  let month = padStart(date.getMonth() + 1, 2, '0');
  let day = padStart(date.getDate(), 2, '0');
  const year = date.getFullYear();
  const hours = padStart(date.getHours(), 2, '0');
  const minutes = padStart(date.getMinutes(), 2, '0');
  return { month, day, year, hours, minutes };
}

export function formatAWSDate(date) {
  const { month, day, year } = getDateInfo(date);
  const awsDate = `${year}-${month}-${day}`;
  return awsDate;
}

export function formatAWSDateTime(date) {
  const { month, day, year, hours, minutes } = getDateInfo(date);
  const awsDate = `${year}-${month}-${day}`;
  const awsDateTime = awsDate + `T${hours}:${minutes}:00.000Z`;
  return awsDateTime;
}

export function formatAmount(amount) {
  if (amount == null) return '$0';
  const formatted = parseFloat(amount).toLocaleString('en-AU', {
    style: 'currency',
    currency: 'AUD',
  });
  // console.log(formatted);
  return formatted;
}
